import type { Severity } from "../lib/format";
import { Sparkline } from "./Sparkline";

interface Props {
  label: string;
  value: string;
  unit?: string;
  severity?: Severity;
  caption?: string;
  sparkline?: number[];
}

export function Tile({
  label,
  value,
  unit,
  severity = "unknown",
  caption,
  sparkline,
}: Props) {
  const hasFooter = sparkline !== undefined || caption !== undefined;

  return (
    <div className={`tile tile-${severity}`}>
      <div className="tile-label">{label}</div>
      <div className="tile-value-row">
        <span className="tile-value">{value}</span>
        {unit ? <span className="tile-unit">{unit}</span> : null}
      </div>
      {hasFooter ? (
        <div className="tile-footer">
          {sparkline !== undefined ? (
            <Sparkline values={sparkline} severity={severity} />
          ) : null}
          {caption ? <div className="tile-caption">{caption}</div> : null}
        </div>
      ) : null}
    </div>
  );
}
